import React from 'react'

import { useFreeBuyBonusStore } from '@stores'

import { FBBDeclineButtons, FBBMainButtons, FBBEndButtons } from '@components'
import { BonusSystemState, BonusSystemDeclineState } from 'game-ui-types'
import { FreeBuyBonusBonus } from '@amusnet/mgs-ws-client'

interface FBBFooterProps {
    bonus?: FreeBuyBonusBonus
}

const FBBFooter: React.FC<FBBFooterProps> = ({ bonus }: FBBFooterProps) => {
    const bonusSystemState = useFreeBuyBonusStore((state) => state.bonusSystemState)
    const bonusSystemDeclineState = useFreeBuyBonusStore((state) => state.bonusSystemDeclineState)

    const isInMainState =
        bonusSystemState === BonusSystemState.SINGLE_BONUS_INITIAL ||
        bonusSystemState === BonusSystemState.MULTIPLE_BONUSES_INITIAL
    const isInDeclineState =
        bonusSystemDeclineState === BonusSystemDeclineState.SINGLE_BONUS_DECLINE ||
        bonusSystemDeclineState === BonusSystemDeclineState.MULTIPLE_BONUSES_DECLINE ||
        bonusSystemDeclineState === BonusSystemDeclineState.BUNDLE_DECLINE
    const isInEndState = bonusSystemState === BonusSystemState.END

    if (isInMainState && !isInDeclineState) {
        return <FBBMainButtons bonus={bonus} />
    } else if (isInDeclineState) {
        return <FBBDeclineButtons bonus={bonus} />
    } else if (isInEndState) {
        return <FBBEndButtons />
    }
}

export default FBBFooter
